module.exports = __webpack_public_path__ + "media/images/verifition/default-c58ae15833e269fc9d427f925fad03ab.jpg";